
// MEMBER MODULE
export const MEMBER_GET_PURCHASED_ORDERS = "MEMBER_GET_PURCHASED_ORDERS";
export const MEMBER_GET_UNAPPROVED_SUPPLIERS = "MEMBER_GET_UNAPPROVED_SUPPLIERS";
export const MEMBER_GET_VENDOR_PARTNER_PURCHASES = "MEMBER_GET_VENDOR_PARTNER_PURCHASES";
export const MEMBER_GET_UNAPPROVED_SUPPLIERS_BY_CATEGORY_DATA = "MEMBER_GET_UNAPPROVED_SUPPLIERS_BY_CATEGORY_DATA";
export const MEMBER_GET_BH_VERIFIED_VENDOR_PARTNER_PURCHASES = "MEMBER_GET_BH_VERIFIED_VENDOR_PARTNER_PURCHASES";
export const MEMBER_GET_INVOICE_DATA = "MEMBER_GET_INVOICE_DATA";
export const MEMBER_GET_TERMINATED_VP_OPPORTUNITIES_DETAILS = "MEMBER_GET_TERMINATED_VP_OPPORTUNITIES_DETAILS";
export const MEMBER_GET_TERMINATED_VP_OPPORTUNITIES = "MEMBER_GET_TERMINATED_VP_OPPORTUNITIES"
export const MEMBER_GET_CARDS_DATA_FOR_MEMBER_DATA_TAB = "MEMBER_GET_CARDS_DATA_FOR_MEMBER_DATA_TAB"
export const MEMBER_GET_CARDS_DATA_FOR_IMARKVERIFIED_DATA_TAB = "MEMBER_GET_CARDS_DATA_FOR_IMARKVERIFIED_DATA_TAB"
export const MEMBER_GET_CHARTS_DATA_PURCHASE_VS_REBATE_EARNED = "MEMBER_GET_CHARTS_DATA_PURCHASE_VS_REBATE_EARNED"
export const MEMBER_GET_CHARTS_DATA_REBATE_EARNED_VS_REBATE_RECEIVED = "MEMBER_GET_CHARTS_DATA_REBATE_EARNED_VS_REBATE_RECEIVED"
export const MEMBER_GET_REBATE_DATA = "MEMBER_GET_REBATE_DATA"
export const MEMBER_GET_REBATE_ESTIMATED_CARDS = "MEMBER_GET_REBATE_ESTIMATED_CARDS"
export const MEMBER_GET_REBATE_NAMES = "MEMBER_GET_REBATE_NAMES"
export const MEMBER_GET_VP_NAMES = "MEMBER_GET_VP_NAMES"
export const MEMBER_GET_UNAPPROVED_SUPPLIERS_NAMES = "MEMBER_GET_UNAPPROVED_SUPPLIERS_NAMES"
export const MEMBER_GET_CATEGORIES_NAMES = "MEMBER_GET_CATEGORIES_NAMES"
export const MEMBER_GET_OVERVIEW_VP_NAMES = "MEMBER_GET_OVERVIEW_VP_NAMES"
export const MEMBER_GET_OVERVIEW_PROGRAM_TYPES_NAMES = "MEMBER_GET_OVERVIEW_PROGRAM_TYPES_NAMES"
export const MEMBER_GET_OVERVIEW_SOURCE_NAMES = "MEMBER_GET_OVERVIEW_SOURCE_NAMES"
export const MEMBER_GET_INVOICES_VP_NAMES = "MEMBER_GET_INVOICES_VP_NAMES"
export const MEMBER_GET_PO_VP_NAMES = "MEMBER_GET_PO_VP_NAMES"
export const MEMBER_GET_TVPO_TVP_NAMES = "MEMBER_GET_TVPO_TVP_NAMES"
export const MEMBER_GET_REBATE_ESTIMATES_CARDS_DATA_FOR_BHVERIFIED_DATA_TAB = "MEMBER_GET_REBATE_ESTIMATES_CARDS_DATA_FOR_BHVERIFIED_DATA_TAB"
export const MEMBER_PURCHASE_WITHIN_IMARK="MEMBER_PURCHASE_WITHIN_IMARK"
export const MEMBER_PURCHASE_OUTSIDE_IMARK="MEMBER_PURCHASE_OUTSIDE_IMARK"
export const MEMBER_OUTSIDE_PURCHASE_BY_CATEGORY="MEMBER_OUTSIDE_PURCHASE_BY_CATEGORY"
export const MEMBER_GET_VERIFIED_REBATE_TRENDS_GRAPH = "MEMBER_GET_VERIFIED_REBATE_TRENDS_GRAPH"
export const MEMBER_VENDOR_NAMES="MEMBER_VENDOR_NAMES"
export const MEMBER_PRODUCT_CATEGPRY="MEMBER_PRODUCT_CATEGPRY"
export const MEMBER_INVOICES_BRANCH = "MEMBER_INVOICES_BRANCH"
export const MEMBER_FBI_ELIGIBLE_CHECK = "MEMBER_FBI_ELIGIBLE_CHECK"
export const MEMBER_FBI_REBATE = "MEMBER_FBI_REBATE"
export const MEMBER_REBATE ="MEMBER_REBATE"
export const MEMBER_BRANCH = "MEMBER_BRANCH"
export const MEMBER_QUALIFICATION = "MEMBER_QUALIFICATION"
export const MEMBER_QUALIFICATION_STATUS = "MEMBER_QUALIFICATION_STATUS"
export const MEMBER_MONTHS_FILTER = "MEMBER_MONTHS_FILTER"
export const MEMBER_CONVERSION_MONTHS_FILTER="MEMBER_CONVERSION_MONTHS_FILTER"
export const MEMBER_VERIFIED_MONTHS_FILTER ="MEMBER_VERIFIED_MONTHS_FILTER"
export const VENDOR_GET_LPG_NAMES_MEMBER = "VENDOR_GET_LPG_NAMES_MEMBER"
export const MEMBER_QUALIFICATION_PURCHASES="MEMBER_QUALIFICATION_PURCHASES"
export const MEMBER_PURCHASE_ORDER_EXCEL = "MEMBER_PURCHASE_ORDER_EXCEL"

export const VENDOR_GET_TERMINATED_VP_NAMES_MEMBER="VENDOR_GET_TERMINATED_VP_NAMES_MEMBER"
export const VENDOR_FULL_INFO="VENDOR_FULL_INFO"
export const VENDOR_OUTSIDE_PURCHASE_PRODUCT_CATEGORY_LIST="VENDOR_OUTSIDE_PURCHASE_PRODUCT_CATEGORY_LIST"

//VENDOR MODULE
export const VENDOR_GET_CATEGORY_OVERVIEW_DATA = "VENDOR_GET_CATEGORY_OVERVIEW_DATA"
export const VENDOR_GET_RANK_BY_CATEGORY_DATA = "VENDOR_GET_RANK_BY_CATEGORY_DATA"
export const VENDOR_GET_INVOICE_DATA = "VENDOR_GET_INVOICE_DATA"
export const VENDOR_GET_SALES_CARD_DATA = "VENDOR_GET_SALES_CARD_DATA"
export const VENDOR_GET_OPPORTUNITY_BY_CATEGORY = "VENDOR_GET_OPPORTUNITY_BY_CATEGORY"
export const VENDOR_GET_TOP_10_CATEGORIES = "VENDOR_GET_TOP_10_CATEGORIES"
export const VENDOR_GET_TOP_10_MEMBERS_DATA = "VENDOR_GET_TOP_10_MEMBERS_DATA"
export const VENDOR_GET_OPPORTUNITY_BY_MEMBER="VENDOR_GET_OPPORTUNITY_BY_MEMBER"
export const VENDOR_GET_TVOPPORTUNITY_BY_CATEGORY="VENDOR_GET_TVOPPORTUNITY_BY_CATEGORY"
export const VENDOR_GET_OVERALL_SALES_DATA_FOR_DASHBOARD_TAB = "VENDOR_GET_OVERALL_SALES_DATA_FOR_DASHBOARD_TAB"
export const VENDOR_GET_INDIVIDUAL_GROWTH_REBATE = "VENDOR_GET_INDIVIDUAL_GROWTH_REBATE"
export const VENDOR_DASHBOARD_GET_REBATES_OVERVIEW = "VENDOR_DASHBOARD_GET_REBATES_OVERVIEW"
export const VENDOR_DASHBOARD_GET_GROUP_GROWTH_REBATE = "VENDOR_DASHBOARD_GET_GROUP_GROWTH_REBATE"
export const VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_GRAPH = "VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_GRAPH"
export const VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_BUSINESS = "VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_BUSINESS"
export const VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_MEMBER = "VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_MEMBER"
export const VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_REGION = "VENDOR_DASHBOARD_GET_SALES_OPPORTUNITY_BY_REGION"
export const VENDOR_GET_OVERVIEW_REBATE_NAMES = "VENDOR_GET_OVERVIEW_REBATE_NAMES"
export const VENDOR_GET_OVERVIEW_SOURCE_NAMES = "VENDOR_GET_OVERVIEW_SOURCE_NAMES"
export const VENDOR_GET_OVERVIEW_BH_NAMES = "VENDOR_GET_OVERVIEW_BH_NAMES"
export const VENDOR_GET_OVERVIEW_VENDOR_PARTNER_VOLUME = "VENDOR_GET_OVERVIEW_VENDOR_PARTNER_VOLUME"
export const VENDOR_GET_DASHBOARD_REBATE_CARDS = "VENDOR_GET_DASHBOARD_REBATE_CARDS";
export const VENDOR_GET_INVOICE_MEMBER_NAME = "VENDOR_GET_INVOICE_MEMBER_NAME";
export const VENDOR_GET_TERMINATED_VP_NAMES = "VENDOR_GET_TERMINATED_VP_NAMES";
export const VENDOR_GET_OVERVIEW_REBATE_NAMES_FILTERED = "VENDOR_GET_OVERVIEW_REBATE_NAMES_FILTERED"
export const VENDOR_GET_OVERVIEW_SOURCE_NAMES_FILTERED = "VENDOR_GET_OVERVIEW_SOURCE_NAMES_FILTERED"
export const VENDOR_PRODUCT_LIST = "VENDOR_PRODUCT_LIST"
export const VENDOR_PRODUCT_CATEGORY = "VENDOR_PRODUCT_CATEGORY"
export const VENDOR_CONEVRSION_TAB_ELIGIBILITY_CHECK = "VENDOR_CONEVRSION_TAB_ELIGIBILITY_CHECK"
export const VENDOR_MONTHS_FILTER ="VENDOR_MONTHS_FILTER"
export const VENDOR_CONVERSION_MONTHS_FILTER ="VENDOR_CONVERSION_MONTHS_FILTER"
export const VENDOR_DASHBOARD_GET_INDIVIDUAL_GROWTH_REBATE ="VENDOR_DASHBOARD_GET_INDIVIDUAL_GROWTH_REBATE"
export const VENDOR_DASHBOARD_GET_MEMBER_PURCHASES_GRAPH="VENDOR_DASHBOARD_GET_MEMBER_PURCHASES_GRAPH"
export const VENDOR_DASHBOARD_GET_MEMBER_LIST="VENDOR_DASHBOARD_GET_MEMBER_LIST"
export const VENDOR_GET_DATE="VENDOR_GET_DATE"

////////Corporate constants
export const CORPORATE_OVERVIEW_OVERALL_SALES_AND_REBATE_DATA = "CORPORATE_OVERVIEW_OVERALL_SALES_AND_REBATE_DATA"
export const CORPORATE_OVERVIEW_REBATE_TYPE_DATA = "CORPORATE_OVERVIEW_REBATE_TYPE_DATA"
export const CORPORATE_OVERVIEW_VENDOR_PARTNER_PERFORMANCE = "CORPORATE_OVERVIEW_VENDOR_PARTNER_PERFORMANCE"
export const CORPORATE_OVERVIEW_MEMBER_PERFORMANCE = "CORPORATE_OVERVIEW_MEMBER_PERFORMANCE"
export const CORPORATE_OVERVIEW_VENDOR_PARTNER_GROUP_PROGRAMS = "CORPORATE_OVERVIEW_VENDOR_PARTNER_GROUP_PROGRAMS"
export const CORPORATE_OVERVIEW_REBATE_NAMES = "CORPORATE_OVERVIEW_REBATE_NAMES"
export const CORPORATE_OVERVIEW_PROGRAM_TYPES = "CORPORATE_OVERVIEW_PROGRAM_TYPES"
export const CORPORATE_OVERVIEW_SOURCE_NAMES = "CORPORATE_OVERVIEW_SOURCE_NAMES"
export const CORPORATE_OVERVIEW_VP_NAMES = "CORPORATE_OVERVIEW_VP_NAMES"
export const CORPORATE_OVERVIEW_GROUP_REBATE_NAMES = "CORPORATE_OVERVIEW_GROUP_REBATE_NAMES"
export const CORPORATE_OVERVIEW_GROWTH_REBATE = "CORPORATE_OVERVIEW_GROWTH_REBATE"
export const CORPORATE_OVERVIEW_BASE_REBATES ="CORPORATE_OVERVIEW_BASE_REBATES"

export const CORPORATE_VENDORDATA_GROWTH_REBATE ="CORPORATE_VENDORDATA_GROWTH_REBATE"
export const CORPORATE_OVERVIEW_VOLUME_CARDS_DATA="CORPORATE_OVERVIEW_VOLUME_CARDS_DATA"
export const CORPORATE_REBATEVIEW_REBATE_SUMMARY = "CORPORATE_REBATEVIEW_REBATE_SUMMARY"
export const CORPORATE_REBATEVIEW_REBATE_OVERVIEW_PROGRAM_TYPES = "CORPORATE_REBATEVIEW_REBATE_OVERVIEW_PROGRAM_TYPES"

export const CORPORATE_OPPORTUNITIES_CARDS_DATA = "CORPORATE_OPPORTUNITIES_CARDS_DATA"
export const CORPORATE_SALES_REBATE_OPPORTUNITIES_TREND = "CORPORATE_SALES_REBATE_OPPORTUNITIES_TREND"
export const CORPORATE_OPPORTUNITIES_REBATE_VS_REBATE_OPPORTUNITY_DATA = "CORPORATE_OPPORTUNITIES_REBATE_VS_REBATE_OPPORTUNITY_DATA"
export const CORPORATE_OPPORTUNITIES_MISSED_OPPORTUNITY_BY_REGION_DATA = "CORPORATE_OPPORTUNITIES_MISSED_OPPORTUNITY_BY_REGION_DATA"
export const CORPORATE_OPPORTUNITIES_UNAPP_SUPP_VOLUME_BY_MEMBER_DATA = "CORPORATE_OPPORTUNITIES_UNAPP_SUPP_VOLUME_BY_MEMBER_DATA"
export const CORPORATE_OPPORTUNITIES_VENDOR_PARTNER_VOLUME_DATA = "CORPORATE_OPPORTUNITIES_VENDOR_PARTNER_VOLUME_DATA"
export const CORPORATE_OPPORTUNITIES_UNAPP_PRODUCT_DATA = "CORPORATE_OPPORTUNITIES_UNAPP_PRODUCT_DATA"
export const CORPORATE_OPPORTUNITIES_MISSED_OPP_BY_BH_CATEGORY_DATA = "CORPORATE_OPPORTUNITIES_MISSED_OPP_BY_BH_CATEGORY_DATA"
export const CORPORATE_OVERVIEW_VP_INVOICES ="CORPORATE_OVERVIEW_VP_INVOICES"
export const CORPORATE_OVERVIEW_MP_INVOICES ="CORPORATE_OVERVIEW_MP_INVOICES"

export const CORPORATE_TVPO_TOP_10_MEMBERS_DATA = "CORPORATE_TVPO_TOP_10_MEMBERS_DATA"
export const CORPORATE_TVPO_VOLUME_OPP_BY_MEMBER = "CORPORATE_TVPO_VOLUME_OPP_BY_MEMBER"
export const CORPORATE_TVPO_VOLUME_OPP_BY_PRODUCT_GROUP_DATA = "CORPORATE_TVPO_VOLUME_OPP_BY_PRODUCT_GROUP_DATA"
export const CORPORATE_TVPO_TOP_10_PRODUCT_GROUPS_DATA = "CORPORATE_TVPO_TOP_10_PRODUCT_GROUPS_DATA"
export const CORPORATE_TVPO_CONVERSION_OPP_PO_DETAILS_DATA = "CORPORATE_TVPO_CONVERSION_OPP_PO_DETAILS_DATA"
export const CORPORATE_TVPO_CONVERSION_OPPORTUNITY_DATA = "CORPORATE_TVPO_CONVERSION_OPPORTUNITY_DATA"

export const CORPORATE_CATEGORY_DETAILS_DATA = "CORPORATE_CATEGORY_DETAILS_DATA"
export const CORPORATE_CATEGORY_DETAILS_BH_NAMES = "CORPORATE_CATEGORY_DETAILS_BH_NAMES"

export const CORPORATE_COMPLIANCE_MEMBER_DETAILS_DATA = "CORPORATE_COMPLIANCE_MEMBER_DETAILS_DATA"
export const CORPORATE_COMPLIANCE_VENDOR_PARTNER_DETAILS_DATA = "CORPORATE_COMPLIANCE_VENDOR_PARTNER_DETAILS_DATA"
export const TOKEN_ERROR = "TOKEN_ERROR"

export const CORPORATE_REBATE_TAB_VP_NAMES = "CORPORATE_REBATE_TAB_VP_NAMES"
export const CORPORATE_REBATE_TAB_REBATE_PROGRAM_NAMES = "CORPORATE_REBATE_TAB_REBATE_PROGRAM_NAMES"
export const CORPORATE_REBATE_TAB_MEMBER_NAMES = "CORPORATE_REBATE_TAB_MEMBER_NAMES"
export const CORPORATE_REBATE_TAB_DATA_SOURCE_NAMES = "CORPORATE_REBATE_TAB_DATA_SOURCE_NAMES"
export const CORPORATE_REBATE_TAB_REBATE_SUMMARY_DATA = "CORPORATE_REBATE_TAB_REBATE_SUMMARY_DATA"
export const CORPORATE_REBATE_TAB_REBATE_OVERVIEW_DATA = "CORPORATE_REBATE_TAB_REBATE_OVERVIEW_DATA"
export const CORPORT_TVPO_TVPO_NAMES = "CORPORT_TVPO_TVPO_NAMES"
export const CORPORATE_FEEDBACK_UNAPPROVED_SUPPLIER_MAPPING = "CORPORATE_FEEDBACK_UNAPPROVED_SUPPLIER_MAPPING"
export const CORPORATE_FEEDBACK_PRODUCTS_NOT_SOLD = "CORPORATE_FEEDBACK_PRODUCTS_NOT_SOLD"
export const CORPORATE_FEEDBACK_WRONG_CATEGORY = "CORPORATE_FEEDBACK_WRONG_CATEGORY"
export const SAVE_VENDOR_ID = "SAVE_VENDOR_ID"
export const SAVE_MEMBER_ID = "SAVE_MEMBER_ID"
export const CORPORATE_FEEDBACK_FAVORABLE_SUPPLIER_FEEDBACK = "CORPORATE_FEEDBACK_FAVORABLE_SUPPLIER_FEEDBACK"
export const CORPORATE_FEEDBACK_INSERT_UNAPPROVED_SUPPLIER_FEEDBACK = "CORPORATE_FEEDBACK_INSERT_UNAPPROVED_SUPPLIER_FEEDBACK"
export const CORPORATE_FEEDBACK_INSERT_WRONG_CATEGORY_FEEDBACK = "CORPORATE_FEEDBACK_INSERT_WRONG_CATEGORY_FEEDBACK"
export const CORPORATE_FEEDBACK_INSERT_PRODUCTS_NOT_SOLD_FEEDBACK = "CORPORATE_FEEDBACK_INSERT_PRODUCTS_NOT_SOLD_FEEDBACK"
export const CORPORATE_FEEDBACK_INSERT_FAVORABLE_SUPPLIER_FEEDBACK = "CORPORATE_FEEDBACK_INSERT_FAVORABLE_SUPPLIER_FEEDBACK"
export const CORPORATE_FAVORABLE_VENDOR_FEEDBACK = "CORPORATE_FAVORABLE_VENDOR_FEEDBACK" 

export const CORPORATE_IN_VENDOR_FEEDBACK = "CORPORATE_IN_VENDOR_FEEDBACK"
export const CORPORATE_LPG_VENDOR_FEEDBACK = "CORPORATE_LPG_VENDOR_FEEDBACK"
export const CORPORATE_BUYSELL_REP_VENDOR_FEEDBACK = "CORPORATE_BUYSELL_REP_VENDOR_FEEDBACK"
export const CORPORATE_OUT_VENDOR_FEEDBACK = "CORPORATE_OUT_VENDOR_FEEDBACK"
export const VENDOR_GET_TERMINATED_VP_NAMES_CORPORATE = "VENDOR_GET_TERMINATED_VP_NAMES_CORPORATE"
export const CORPORATE_FBI_REBATE ="CORPORATE_FBI_REBATE"
export const CATEGORY_PRODUCTS_DETAILS ="CATEGORY_PRODUCTS_DETAILS"
export const CORPORATE_PRODUCT_CATEGORY ="CORPORATE_PRODUCT_CATEGORY"
export const MONTHS_FILTER = "MONTHS_FILTER"
export const CORPORATE_CONVERSION_MONTHS_FILTER = "CORPORATE_CONVERSION_MONTHS_FILTER"
export const CORPORATE_OPPORTUNITY_MONTHS_FILTER = "CORPORATE_OPPORTUNITY_MONTHS_FILTER"
export const MEMBER_VENDOR_NAMES1 = "MEMBER_VENDOR_NAMES1"

//Corporate Compliance tab API 
export const CORPORATE_COMPLIANCE_MEMBER = "CORPORATE_COMPLIANCE_MEMBER"
export const CORPORATE_COMPLIANCE_VENDOR = "CORPORATE_COMPLIANCE_VENDOR"
export const CORPORATE_COMPLIANCE_YEAR_FILTER = "CORPORATE_COMPLIANCE_YEAR_FILTER"
//Compliance tab api ends

export const STATE_REGIONS = "STATE_REGIONS"
export const STATE_TO_STATE_MAPPING = "STATE_TO_STATE_MAPPING"
export const MEMBER_FAVORABLE_SUPPLIER_FEEDBACK = "MEMBER_FAVORABLE_SUPPLIER_FEEDBACK"

export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export const VERIFY_TOKEN = "VERIFY_TOKEN"
export const UPDATE_PASSWORD = "UPDATE_PASSWORD"
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const TAB_TRACKING = "TAB_TRACKING"
export const SWITCH_DASHBOARD = "SWITCH_DASHBOARD"
//to give feedback